import styled from 'styled-components';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-67b64l-0' })`
    display: contents;
`;
